"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComboBoxInput = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _withFocusClassName = require("../../../../util/withFocusClassName");
var _menuTheme = require("../../../menu/styled/menuTheme");
var _formInputTheme = require("../../../textinput/styled/formInputTheme");
var _selectV2Theme = require("../selectV2Theme");
const ComboBoxInput = (0, _withFocusClassName.withFocusToggleClassName)((0, _styled.default)("input")`
    display: block;
    width: 100%;
    // Override some UA styles.
    font-family: inherit;
    font-size: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _menuTheme.menuTheme.fontSize(themeMode);
}};
    line-height: 18px;
    padding: ${_ref2 => {
  let {
    isContentBeforeVisible,
    themeMode
  } = _ref2;
  return isContentBeforeVisible ? "0 0 0 0" : `0 0 0 ${_selectV2Theme.selectV2Theme.input.padding.left(themeMode)}`;
}};
    height: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return _formInputTheme.formInputTheme.height(themeMode);
}}px;
    box-sizing: border-box;
    border-radius: 4px;
    position: relative;

    // To show over the selected value facade.
    z-index: 1;

    border: 0px;
    background-color: transparent;
    cursor: inherit;

    &:focus,
    &:focus-visible {
        outline: none;
    }
`);
exports.ComboBoxInput = ComboBoxInput;
//# sourceMappingURL=ComboBoxInput.js.map